import React, { useState } from "react";
import ValidationText from "../../../utils/validation/ValidationText";
import Selector from "../../dropdown/commonDropdown/Selector";
import ImageCropperWithUpload from "../../ImageUpload/UploadImage";
import TextInput from "../../UIComponent/TextInput";
import Option from "../../dropdown/multiSelectDropdownOption/MultiSelectOption";
import MultiSelectDropdown from "../../dropdown/MultiSelectDropdown";
import ChangePassword from "../../../pages/authentication/ChangePassword"

function CreateAdmin(props) {
  const [openChangePasswordModal, setopenChangePasswordModal] = useState(false)
  let closeBuyChapterModal = () => {
    setopenChangePasswordModal(false)
  };

  // let openBuyChapterModal = () => {
  //   setopenChangePasswordModal(true)
  // };
  return (
    <div>
      <div className="grid grid-cols-12 gap-6 w-full pb-3 px-5 py-4">
        <div className="xl:col-span-12 lg:col-span-12 col-span-12">
          <div className="grid grid-cols-12 gap-6 w-full ">
            <div className="xl:col-span-6 lg:col-span-6 col-span-12">
              <div className="grid grid-cols-12 gap-6 w-full ">
                <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                  <div className="grid grid-cols-12 gap-6">
                    <div className="2xl:col-span-11 lg:col-span-12 col-span-12">
                      <h2 className="theme-label">
                        First Name
                        <span className="text-[#f72b2b]">*</span>
                      </h2>
                      <div className="flex items-center">
                        <TextInput
                          placeholder=""
                          type="text"
                          name="name"
                          value={props.adminDetails.name}
                          identity="adminDetails"
                          handleChange={props.handleChange}
                          onBlur={(e) => props.ValidateAdminDetails("name")}
                        />


                      </div>
                      <ValidationText
                        error={props.validState.error.name}
                      />
                    </div>
                    <div className="2xl:col-span-11 lg:col-span-12 col-span-12">
                      <h2 className="theme-label">
                        Last Name
                        <span className="text-[#f72b2b]">*</span>
                      </h2>
                      <div className="flex items-center">
                        <TextInput
                          placeholder=""
                          type="text"
                          name="lastName"
                          value={props.adminDetails.lastName}
                          identity="adminDetails"
                          handleChange={props.handleChange}
                          onBlur={(e) => props.ValidateAdminDetails("lastName")}
                        />

                      </div>
                      <ValidationText
                        error={props.validState.error.lastName}
                      />
                    </div>
                    <div className="2xl:col-span-11 lg:col-span-12 col-span-12">
                      <h2 className="theme-label">
                        Email
                        <span className="text-[#f72b2b]">*</span>
                      </h2>
                      <div className="flex items-center">
                        <TextInput
                          placeholder=""
                          type="email"
                          name="email"
                          value={props.adminDetails.email}
                          identity="adminDetails"
                          handleChange={props.handleChange}
                          onBlur={(e) => props.ValidateAdminDetails("email")}
                          autoComplete="off"
                        />


                      </div>
                      <ValidationText
                        error={props.validState.error.email}
                      />
                    </div>
                    {props.adminId && props.adminId > 0 ?
                      null
                      :
                      <div className="2xl:col-span-11 lg:col-span-12 col-span-12">
                        <h2 className="theme-label">
                          Password
                          <span className="text-[#f72b2b]">*</span>
                        </h2>
                        <div className="flex items-center">
                          <TextInput
                            placeholder=""
                            type="password"
                            name="password"
                            value={props.adminDetails.password}
                            identity="adminDetails"
                            handleChange={props.handleChange}
                            onBlur={(e) => props.ValidateAdminDetails("password")}
                            autoComplete="new-password"
                          />


                        </div>
                        <ValidationText
                          error={props.validState.error.password}
                        />
                      </div>
                    }

                    {/* Role Start */}
                    <div className="2xl:col-span-11 lg:col-span-12 col-span-12">
                      <h2 className="theme-label">
                        Role
                        <span className="text-[#f72b2b]">*</span>
                      </h2>

                      <div className="dropdwn-input flex items-center">
                        <div className="w-full">
                          <Selector
                            drpIdentity="AdminRole"
                            options={props.adminRoleList}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{ Option, }}
                            onChange={props.handleChangeMultiDropdown}
                            allowSelectAll={true}
                            value={props.adminDetails.selectedRole}
                          />
                        </div>
                      </div>
                      <ValidationText
                        error={props.validState.error.selectedRole}
                      />
                    </div>

                    {/* Role End */}
                  </div>


                </div>

              </div>
              {props.adminId && props.adminId > 0 ?

                <div className="grid grid-cols-12 gap-6 mt-14">
                  <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                    <a href="#."
                      className="flex items-center justify-start"
                    >

                      <button className="btn btn-red"
                        onClick={() => setopenChangePasswordModal(true)}
                      >
                        Reset Password
                      </button>
                    </a>
                  </div>
                </div>
                : null}
            </div>
            <div className="xl:col-span-6 lg:col-span-6 col-span-12">
              <div className="adminaccount-info-croper company-logo-cropper ml-auto mr-auto mt-8">
                <ImageCropperWithUpload
                  key="Main"
                  height={250}
                  width={350}
                  isCheckValidation={true}
                  MaxFileSize={2097152}
                  MaxFileSizeMessage={"2MB"}
                  onSaveImage={props.saveMainImage}
                  imageIdentity="Admin"
                  intitImage={props.adminDetails.profilePic}
                  aspactRatio={350 / 250}
                  uploadBtn={"Upload Profile Photo"}
                  dimensionText={
                    "(Dimension: 200px by 200px Maximum Size: 2MB)"
                  }
                />
              </div>
            </div>
            {openChangePasswordModal && (
              <div className="xl:col-span-12 lg:col-span-12 col-span-12">
                <div className="change-password-sec">
                  <ChangePassword
                    key={"ChangePasswordModal"}
                    authDetails={props.adminDetails}
                    openChangePasswordModal={openChangePasswordModal}
                    setOpenModal={() => closeBuyChapterModal()}
                    onClose={() => closeBuyChapterModal()}
                  />
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAdmin;
